@let userDetails = authStateService.select('userDetails') | async;
@let profilePhoto = profileStateService.select('profilePhotoUrl') | async;
@let groupData = userGroupStateService.selectAll() | async;
@let hasVendorGroup = userGroupStateService.select('hasVendorGroup') | async;

<nav
    class="header-class bg-color-header sticky top-0 z-40 w-full text-gray-700 dark:text-gray-200">
    <div class="mx-auto flex h-14 items-center gap-2 px-4">
        <button
            type="button"
            (click)="toggleSidebar()"
            aria-label="Toggle navigation menu"
            pTooltip="Menu"
            tooltipPosition="bottom"
            class="focus-visible:ring-primary/60 inline-flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full transition-colors hover:bg-gray-100 focus-visible:ring-2 focus-visible:outline-none dark:hover:bg-gray-800">
            <i class="pi pi-bars secondary-text text-xl"></i>
        </button>

        <a
            class="flex shrink-0 items-center md:hidden"
            aria-label="Hair Style Club home"
            [routerLink]="['/dashboard/home']">
            <img
                src="assets/logo/hairstyleclub-full-logo.png"
                class="h-7 w-auto cursor-pointer object-contain"
                alt="Hair Style Club" />
        </a>

        <div class="flex-1"></div>

        <div class="flex shrink-0 items-center gap-1.5 sm:gap-2">
            <div class="client-org-selector relative hidden items-center">
                <div
                    (click)="toggleOrgDropdown()"
                    [attr.title]="organization()?.name ?? ''"
                    class="group flex max-w-[220px] cursor-pointer items-center gap-2 rounded-full bg-white px-3 py-1.5 ring-1 ring-black/5 transition-all duration-300 hover:shadow-sm active:scale-[0.98] xl:max-w-[260px] dark:bg-gray-800 dark:ring-white/10">
                    <span
                        class="text-primary flex shrink-0 transition-colors duration-300">
                        <i
                            class="pi pi-building"
                            style="font-size: 1.15rem"></i>
                    </span>
                    <span class="flex min-w-0 flex-col">
                        <span
                            class="truncate text-[10px] font-semibold tracking-wider text-gray-400 uppercase">
                            {{ userDetails?.user?.firstName }}
                            {{ userDetails?.user?.lastName }}
                        </span>
                        <span class="-mt-0.5 flex items-center gap-1.5">
                            <span
                                class="text-card-title truncate text-sm font-bold">
                                {{
                                    $safeNavigationMigration(
                                        organization()?.name
                                    ) | textSlice: 25
                                }}
                            </span>
                            <i
                                #orgChevron
                                class="pi pi-chevron-down shrink-0 text-[10px] transition-transform duration-300"
                                [class.rotate-180]="isOrgDropdownVisible()"></i>
                        </span>
                    </span>
                </div>

                @if (isOrgDropdownVisible()) {
                    <app-group-list-items
                        #orgDropdown
                        class="animate-in fade-in zoom-in-95 absolute top-12 -left-16 z-50 w-72 origin-top rounded-2xl bg-white p-2 shadow-xl ring-1 ring-black/5 duration-200 dark:bg-gray-900 dark:ring-white/10"
                        [groupData]="groupData ?? null"
                        [hasVendorGroup]="hasVendorGroup ?? false"
                        [selectedGroupId]="selectedGroupId() ?? ''"
                        [isLoading]="isLoading()"
                        [groupId]="authStateService.getOrganizationId() ?? ''"
                        (onNavigate)="onNavigate($event)"
                        (onSwitchGroup)="onSwitchGroup($event)" />
                }
            </div>

            <app-header-quick-settings />

            <button
                type="button"
                (click)="notificationsClick.emit()"
                aria-label="Notifications"
                pTooltip="Notifications"
                tooltipPosition="bottom"
                class="focus-visible:ring-primary/60 relative inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors hover:bg-gray-100 focus-visible:ring-2 focus-visible:outline-none dark:hover:bg-gray-800">
                <i class="pi pi-bell secondary-text text-lg"></i>
                @if (notificationCount > 0) {
                    <span
                        class="bg-primary absolute top-0.5 right-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full px-1 text-[9px] leading-none font-bold text-white">
                        {{ notificationCount > 9 ? '9+' : notificationCount }}
                    </span>
                }
            </button>

            <button
                type="button"
                (click)="onViewDropDown()"
                aria-label="Open account menu"
                class="focus-visible:ring-primary/60 inline-flex shrink-0 items-center justify-center rounded-full transition-transform focus-visible:ring-2 focus-visible:outline-none active:scale-95">
                <user-login-status
                    [user]="
                        $safeNavigationMigration(userDetails?.user?.firstName) +
                        ' ' +
                        $safeNavigationMigration(userDetails?.user?.lastName)
                    "
                    [verifiedAt]="
                        $safeNavigationMigration(userDetails?.user?.verifiedAt)
                    "
                    [profilePhoto]="profilePhoto ?? ''"
                    [userFirstName]="userDetails?.user?.firstName ?? ''" />
            </button>
        </div>

        @if (isVisible()) {
            <app-client-profile-dropdown
                #dropdown
                [isVisible]="isVisible()"
                [organization]="organization()"
                [groupType]="groupType()"
                [isLoading]="isLoading()"
                [selectedGroupId]="selectedGroupId()"
                (close)="onDropdownClose()"
                (navigate)="onNavigate($event)"
                (switchGroup)="onSwitchGroup($event)"
                (upgradeSubscription)="onUpgradeSubscription($event)"
                (loadOwnedGroups)="onLoadOwnedGroups($event)" />
        }
    </div>
</nav>
